import type { VehicleByAudiCode, StockCarTypes } from '../types';

type getVehicleDataToSubmitTypes = {
  vehicle: StockCarTypes | undefined;
  vehicleByCarline: VehicleByAudiCode | undefined;
  vehicleByAudiCode: VehicleByAudiCode | undefined;
  audiCodeFYM: string | undefined;
  isTier3: boolean;
  vehicleOfInterest?: string | undefined;
};

export const getVehicleDataToSubmit = ({
  vehicle,
  vehicleByAudiCode,
  vehicleByCarline,
  audiCodeFYM,
  isTier3,
  vehicleOfInterest,
}: getVehicleDataToSubmitTypes) => {
  if (vehicleByAudiCode) {
    return {
      make: 'Audi',
      model: vehicleByAudiCode.titleText,
      year: vehicleByAudiCode.model.salesModelyear,
      trim: vehicleByAudiCode.subtitleText,
      options: [{ manufacturerCode: vehicleByAudiCode.audiCode, name: 'audiCode' }],
    };
  }

  if (vehicleByCarline) {
    return {
      make: 'Audi',
      model: vehicleByCarline.titleText,
      year: vehicleByCarline.model.salesModelyear,
    };
  }

  if (vehicle) {
    const {
      vin,
      commissionNumber,
      carPrices,
      cartypeText,
      model,
      dynamicAttributes,
      titleText,
      modelInfo,
      subtitleText,
      colorInfo,
      manufacturerSpecificItems,
      qualityLabel,
    } = vehicle;

    // Mapping different data based on Tier
    const msrp =
      carPrices?.find((toCheck) => toCheck.type === 'list')?.price?.value ||
      carPrices?.find((toCheck) => toCheck.type === 'final')?.price?.value;
    const dealerPrice = carPrices?.find((toCheck) => toCheck.type === 'final')?.price?.value || '';
    const modelPrice = isTier3 ? dealerPrice : msrp;
    const bodyType = manufacturerSpecificItems?.cdbItems?.find((item) => item?.id === 'body-type')
      ?.value?.length
      ? manufacturerSpecificItems?.cdbItems?.find((item) => item?.id === 'body-type')?.value
      : '';
    const stockNumberTier3 = dynamicAttributes?.find(
      (toCheck) => toCheck.id === 'VEHICLE_ID',
    )?.value;
    const make = titleText?.includes('Audi') ? 'Audi' : titleText;

    const getVehicleType = () => {
      if (cartypeText === 'U' && qualityLabel.length) return 'CPO';
      if (cartypeText === 'U' && !qualityLabel.length) return 'USED';
      return 'NEW';
    };

    return {
      vin,
      stockNumber: isTier3 ? stockNumberTier3 : commissionNumber,
      msrpTotal: modelPrice,
      status: getVehicleType(),
      year: model?.salesModelyear,
      make,
      model: modelInfo?.genericModel?.text,
      trim: subtitleText,
      exteriorColor: colorInfo?.exteriorColor?.colorInfo?.text,
      bodyType,
      options: audiCodeFYM ? [{ manufacturerCode: audiCodeFYM, name: 'audiCode' }] : [],
      // fuelType: engineInfo?.fuel?.text,
    };
  }

  if (vehicleOfInterest) {
    return {
      make: 'Audi',
      model: vehicleOfInterest,
    };
  }

  return undefined;
};
